export default __webpack_public_path__ + "static/media/SFUIDisplay-Medium.0aec296a.ttf";